.RCTDContainer
    position: fixed
    left: 0
    right: 0
    top: 0
    bottom: 0
    margin: 0
    padding: 20px 0
    display: flex
    flex-direction: column
    border-radius: $globalSettingsRounding
    font-size: 14px
    color: rgb($globalSettingsFontPrimary)
    background-color: rgb($globalSettingsBackgroundPrimary)
    box-sizing: border-box
    overflow: hidden
    z-index: $indexCart
    opacity: 0
    animation: 0.2s ease-in-out 0s 1 openCartDetails
    animation-fill-mode: forwards
    .RCTDInner
        max-width: 100%
        flex-grow: 1
        display: flex
        flex-direction: column
        min-height: 0
        overflow-x: hidden
        overflow-y: auto
    .RTCDHeader
        width: 100%
        padding: 0 20px
        display: flex
        flex-direction: row
        gap: 10px
        justify-content: space-between
        align-items: center
        .RTCDHeaderTitle
            font-weight: 700
    .RTCDAccordionExpandedTitle
        width: 100%
        height: 40px
        display: flex
        justify-content: space-between
        align-items: center
        font-weight: 700
    .RTCDArrowOpened
        transform: rotate(180deg)
    .RTCDFooter
        width: 100%
        padding: 0 20px
        display: flex
        flex-direction: column
        .RTCDFooterInfo
            width: 100%
            display: flex
            flex-direction: row-reverse
            justify-content: space-between
            align-items: flex-end
        .RTCDFooterPriceContainer
            display: flex
            flex-direction: row
            align-items: center
            gap: 10px
            stroke: rgb($globalSettingsFontPrimary)
            color: rgb($globalSettingsFontPrimary)
            cursor: pointer
            &:hover
                stroke: rgb($globalSettingsFontSecondary)
                color: rgb($globalSettingsFontSecondary)
            .RTCDFooterPrice
                display: flex
                flex-direction: column
                align-items: flex-end
                .RTCDFooterTotal
                    font-weight: 700
                .RTCDFooterDeposit
                    font-size: 12px
.RTCDAccordionRow
    padding: 0 20px
.RCTDTimer
    position: relative
    display: flex
    width: calc(100% - 40px)
    margin: 20px
    padding: 20px
    flex-direction: column
    justify-content: center
    align-items: center
    border-radius: $globalSettingsRounding
    font-size: 14px
    background: rgb($globalSettingsBackgroundTertiary)
    overflow-x: hidden
    overflow-y: auto
    box-sizing: border-box
    .RCTDInfoBold
        font-size: 18px
        font-weight: 700

@keyframes openCartDetails
    0%
        opacity: 0
        transform: translateY(20px)

    100%
        opacity: 1
        transform: translateY(0)
